<script>
import SharedDocument from '@components/safehaven/share/shared-document.vue'
import MyDocument from '@components/safehaven/share/my-documents.vue'
import RecivedDocument from '@components/safehaven/share/received-documents.vue'

export default {
  page: {
    title: 'Document Center',
    meta: [{ name: 'description', content: 'The Document Center page.' }],
  },
  components: {
    MyDocument,
    SharedDocument,
    RecivedDocument,
  },
  data() {
    return {
      loading: false,
    }
  },
  created() {
    setTimeout(
      function () {
        if (
          this.$store.state.calender.sharedRecordTabs === 'received-documents'
        )
          document.getElementById('receivedTabID').click()
      }.bind(this),
      1000
    )
  },
}
</script>

<template>
  <v-container class="pa-0 mt-5 mb-12" fluid>
    <v-row v-if="loading" no-gutters>
      <v-card width="100%" color="offwhite" outlined rounded="lg" loading>
        <template slot="progress">
          <v-progress-linear
            v-if="loading"
            color="primary"
            indeterminate
          ></v-progress-linear>
        </template>
      </v-card>
    </v-row>
    <v-row :class="$vuetify.breakpoint.mdAndDown ? 'px-5 mt-0' : ''">
      <v-col
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '10'"
        lg="10"
        xl="10"
        class="ma-auto"
        :class="[$vuetify.breakpoint.mobile ? 'pr-1 pl-1' : 'pr-10 pl-10']"
        fill-height
      >
        <h3
          :class="[
            [$vuetify.breakpoint.mobile ? '' : 'mt-3'],
            $style.peerHeading,
          ]"
          >Document Center</h3
        >
      </v-col>
    </v-row>
    <v-row :class="$vuetify.breakpoint.mdAndDown ? 'px-5' : 'mt-0'">
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
      <v-col
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '8'"
        lg="8"
        xl="9"
        class="my-auto"
        :class="[
          $vuetify.breakpoint.mobile
            ? 'pr-1 pl-1 ' + $style.subheading
            : 'pr-10 pl-10 ' + $style.subheading,
        ]"
        fill-height
      >
        Upload and store all your healthcare related documents in one secure
        place. This may include medical bills, insurance statements, legal
        paperwork or identification cards. You can select and share documents
        with others and specify the amount of time they can access and view
        them.
      </v-col>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '2'"
        lg="2"
        xl="2"
        class="text-left"
        :class="[$vuetify.breakpoint.mobile ? 'pr-1 pl-1' : 'pr-10 pl-10']"
        fill-height
      >
        <img :src="require('@assets/images/safehaven/Secure-Badge.svg')" />
      </v-col>
    </v-row>
    <v-row :class="$vuetify.breakpoint.mdAndDown ? 'px-5' : ''">
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
      <v-col
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '11'"
        lg="11"
        xl="11"
        class="my-auto"
        :class="[$vuetify.breakpoint.mobile ? 'pr-1 pl-1' : 'pr-10 pl-10']"
      >
        <v-tabs
          next-icon="mdi-arrow-right-bold-circle"
          prev-icon="mdi-arrow-left-bold-circle"
          :show-arrows="false"
          center-active
          background-color="transparent"
          :class="[
            $style.tabClss,
            $vuetify.breakpoint.smAndUp ? 'mt-0' : 'mt-0',
          ]"
          color="rgba(0, 0, 0, 0.87)"
        >
          <v-tab key="1">My Documents</v-tab>
          <v-tab id="ShareDocTabID" key="2">Shared Documents</v-tab>
          <v-tab id="receivedTabID" key="3">Received Documents</v-tab>

          <v-tab-item><MyDocument></MyDocument></v-tab-item>
          <v-tab-item><SharedDocument></SharedDocument></v-tab-item>
          <v-tab-item><RecivedDocument></RecivedDocument></v-tab-item>
        </v-tabs>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12"></v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.peerHeading {
  font-size: 22px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}

.subheading {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #454648;
  text-align: left;
  letter-spacing: 0;
}
</style>

<style scoped>
.v-tab {
  min-width: inherit !important;
  max-width: inherit !important;
  padding: 0;
  margin-right: 50px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}

/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background: #93c0e8 !important;
}

/deep/ .theme--light.v-btn.v-btn--disabled,
.theme--light.v-btn.v-btn--disabled .v-btn__loading,
.theme--light.v-btn.v-btn--disabled .v-icon {
  color: #fff !important;
}
/deep/ .v-slide-group__next--disabled {
  display: none !important;
}
/deep/ .v-slide-group__prev--disabled {
  display: none !important;
}

/deep/ .theme--light.v-tabs-items {
  background-color: transparent !important;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #0476d9 !important;
}

.v-tab--active {
  font-weight: 600 !important;
}
/deep/ .v-tabs-slider-wrapper {
  bottom: 8px !important;
}

/deep/ .theme--light.v-tabs .v-tab--active::before,
.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab:focus::before {
  opacity: 0;
}
/deep/ .theme--light.v-tabs .v-tab:hover::before {
  opacity: 0;
}
/deep/ .v-ripple__container {
  display: none !important;
}

@media screen and (max-width: 959px) {
  /deep/ .v-tabs-bar {
    padding: 0 12px;
  }
}
</style>
